<template>
  <div class="weixin-tip">
    <van-icon name="checked" color="#07c160"/>
    <h4 class="weui_msg_title">微信支付成功</h4>
    <van-button type="primary" size="small" @click="toPayList">返回个人中心查看</van-button>
  </div>
</template>

<script>
export default {
  name: 'PayResult',
  data() {
    return {
      isCancel: false,
      orderAmount: 0
    }
  },
  created() {
    // localStorage.setItem('openId', "")
    // 判断是否在小程序Webview环境中
    // this.isWxMini = window.__wxjs_environment === 'miniprogram';
    // if (this.isWxMini) {
    // } else {
    //   console.log("created 当前环境：微信浏览器 WebView")
    // }
  },
  mounted() {
    this.orderAmount = +this.$route.query.orderAmount
  },
  methods: {
    toPayList() {
      this.$router.push('/My')
    },
  }
}
</script>

<style lang="less" scoped>
.weixin-tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  .van-icon {
    font-size: 60px;
    color: #10AEFF;
  }

  h4 {
    font-size: 20px;
    font-weight: 400;
    padding: 15px 0;
    margin: 0;
  }

  .small-fee-number {
    color: #ff3b45;
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/routerPages/PayResult.vue